import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { getInvoicesByCandidateId, IClientInvoice, InvoiceDTO } from 'wisestep-api';

import RelatedInvoices from '../RelatedInvoices';

const ContractorInvoiceDetailRelatedInvoicesContainer = ({
  invoice,
}: {
  invoice: IClientInvoice;
}) => {
  const form = useForm();
  const candidates = invoice.lineItems
    .filter((item) => item.type === 'CLOSURE')
    .map((item) => item.contractPlacement!.candidate!);
  const [invoices, setInvoices] = useState<InvoiceDTO[] | null>(null);
  const candidateId = form.watch('candidateId');
  const candidateName = candidateId ? candidates.find((c) => c.id === candidateId)?.name : '';

  useEffect(() => {
    (async () => {
      if (candidateId) {
        setInvoices(null);
        const invoicesResp = await getInvoicesByCandidateId(candidateId, 'CONTRACTOR');
        const previousInvoices = invoicesResp.data.filter((i) => i.id !== invoice.id);
        setInvoices(previousInvoices);
      }
    })();
  }, [candidateId, invoice.id]);

  useEffect(() => {
    if (candidates.length > 0) {
      form.setValue('candidateId', candidates[0].id);
    }
  }, [candidates, form]);

  return (
    <>
      <FormProvider {...form}>
        <RelatedInvoices
          candidates={candidates}
          candidateName={candidateName}
          invoices={invoices}
        />
      </FormProvider>
    </>
  );
};

export default ContractorInvoiceDetailRelatedInvoicesContainer;
